const homeRouteName = "/";
const tellMeHomeRouteName = "/tell_me";
const tellMeWatchRouteName = "/tell_me_watch";


const routes = {
    homeRouteName,
    tellMeHomeRouteName,
    tellMeWatchRouteName
}
export default routes;